import Vue from 'vue'
import Vuex from 'vuex'

import keepAliveTag from './keepAliveTag'
import user from './user'
import sys from './sys'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: null,
    screenHeight: null,
  },
  mutations: {
    SET_SCREEN_WIDTH (state, data) {
      state.screenWidth = data
    },
    SET_SCREEN_HEIGHT (state, data) {
      state.screenHeight = data
    }
  },
  actions: {
    setScreenWidth ({ commit }, data) {
      commit('SET_SCREEN_WIDTH', data)
    },
    setScreenHeight ({ commit }, data) {
      commit('SET_SCREEN_HEIGHT', data)
    }
  },
  getters: {
    screenWidth: state => {
      return state.screenWidth
    },
    screenHeight: state => {
      return state.screenHeight
    },
    screenSize: state => {
      if (state.screenWidth >= 1200) {
        return 'lg'
      } else if (state.screenWidth >= 970) {
        return 'md'
      } else if (state.screenWidth >= 750) {
        return 'sm'
      } else {
        return 'xs'
      }
    }
  },
  modules: {
    keepAliveTag: keepAliveTag,
    user: user,
    sys: sys
  }
})
